import areaAddressApi from '../../features/endPoints/thirdPartyEndpoints';
import { createApiInstance } from '../../foundation/api';

const areaAddressClient = createApiInstance(
  'https://api.edq.com/',
  false
);
const formatAddressAuthClient = createApiInstance(
  'https://api.edq.com/',
  false
);

export { areaAddressClient, formatAddressAuthClient, areaAddressApi };
